import styled from 'styled-components';
import { ActionBar } from 'components/molecules/action-bar';

const PrimaryBlock = styled.div`
  height: 100%;
  /* width: calc(100% - var(--layout-03)); */
`;

const Tags = styled.div`
  flex: 1;
  padding: 0 var(--spacing-05);
  margin-top: -12px;
  .ant-tag {
    margin: 0;
  }
`;

type Header = typeof ActionBar & {
  PrimaryBlock: typeof PrimaryBlock;
  Tags: typeof Tags;
};

const Header: Header = styled(ActionBar)`
  ${ActionBar.Primary} {
    flex: 0 0 75%;
    overflow: hidden;
    height: 34px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
` as any;

Header.Primary = ActionBar.Primary;
Header.Secondary = ActionBar.Secondary;
Header.Hanger = ActionBar.Hanger;
Header.PrimaryBlock = PrimaryBlock;
Header.Tags = Tags;

export { Header };
